<template>
  <section class="padding-bottom-needed">
    <br>
    <h1 class="title">
      {{ $root.pageTitle }}
    </h1>
    <div class="columns">
      <div class="columns">
        <div class="column is-6 is-paddingless">
          <p style="margin-bottom: 2em;">
            Manage time limites, notification types and optional steps
          </p>

          <form>
            <h5 class="has-text-weight-bold">
              Name your workflow
            </h5>
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Workflow title</span>
                  <span
                    :data-tooltip="'Required field' + '\n' + 'Allowed character count is 50'"
                    class="tooltip has-tooltip-right has-tooltip-arrow"
                  >
                    <img
                      src="../../../public/assets/img/info.svg"
                      alt=""
                    >
                  </span>
                </label>
                <input
                  ref="title"
                  v-model="wf.workflow.name"
                  class="input is-normal is-mandatory"
                  type="text"
                  name="workflow_name"
                  :class="errors.workflowName.visible ? 'has-error' : ''"
                  placeholder="Eg: Custom workflow"
                >
                <span v-if="errors.workflowName.visible">{{ errors.workflowName.message }}</span>
              </div>
            </div>
            <br>

            <input
              v-if="wf.workflow.uuid"
              type="hidden"
              name="workflow_uuid"
              :value="wf.workflow.uuid"
            >

            <h5 class="has-text-weight-bold">
              Manage steps
            </h5>
            <div
              id="stepEditor"
              class="timeline"
            >
              <div class="timeline-item timeline-item-start">
                <div class="timeline-marker" />
                <div class="timeline-content">
                  <span>Due date</span>
                  <span
                    class="info"
                    style="position: relative"
                  ><span
                    class="is-warning"
                    style="width: 16px; height: 16px; border-radius: 50%; display: inline-block; position: absolute; left: -24px; top: 50%; transform: translateY(-50%);"
                  /> Mandatory steps</span>
                </div>
              </div>

              <div
                id="generatedSteps"
                ref="steps"
              >
                <draggable
                  v-model="wf.formatted_step"
                  group="step"
                  animation="150"
                  ghost-class="dragged"
                  handle=".is-draggable"
                  easing="cubic-bezier(1, 0, 0, 1)"
                  filter=".required"
                  @start="drag=true"
                  @end="dragEnd"
                >
                  <div
                    v-for="(step, index) in wf.formatted_step"
                    :key="index"
                    class="timeline-item"
                  >
                    <div
                      class="timeline-marker"
                      :class="[step.is_mandatory ? 'is-warning' : (step.show_details ? 'is-icon is-draggable is-info' : 'is-draggable')]"
                      style="font-family: monospace"
                    >
                      <i
                        v-if="!step.is_mandatory && step.show_details"
                        class="fas fa-arrows-alt"
                        aria-hidden="true"
                      />
                    </div>
                    <div class="timeline-content">
                      <step-new-edit
                        :step="step"
                        :index="index"
                        :tpl_list="tpl"
                        :workflow="wf"
                        @delete-step="deleteStep(index)"
                        @save-workflow="saveWorkflow()"
                        @computePeriods="step.current_period = $event; computePeriods()"
                        @validate-step="step = $event; validateStep(step)"
                        @update-step="(params) => updateStep(params, index)"
                        @toggle="step.show_details = !step.show_details"
                        @change="onChange($event, index)"
                      />
                    </div>
                  </div>
                </draggable>
              </div>

              <div class="timeline-item timeline-item-end">
                <div class="timeline-marker" />
              </div>
            </div>
          </form>
        </div>
        <div class="column is-5 is-offset-1">
          <div
            class="notice-block"
            style="display: flex"
          >
            <i
              class="fas fa-question-circle fa-fw fa-2x"
              aria-hidden="true"
              style="margin-right: 1.125rem"
            />
            <div class="content">
              <p class="has-text-weight-bold">
                {{ stateName }} State Compliant Workflow
              </p>
              <p v-html="legalRules" />
            </div>
          </div>

          <!-- <h5 class="has-text-weight-bold">
            Manage steps
          </h5>
          <div
            id="stepEditor"
            class="timeline"
          >
            <div class="timeline-item timeline-item-start">
              <div class="timeline-marker" />
              <div class="timeline-content">
                <span>Due date</span>
                <span
                  class="info"
                  style="position: relative"
                ><span
                  class="is-warning"
                  style="width: 16px; height: 16px; border-radius: 50%; display: inline-block; position: absolute; left: -24px; top: 50%; transform: translateY(-50%);"
                /> Mandatory steps</span>
              </div>
            </div>

            <div
              id="generatedSteps"
              ref="steps"
            >
              <draggable
                v-model="wf.formatted_step"
                group="step"
                animation="150"
                ghost-class="dragged"
                handle=".is-draggable"
                easing="cubic-bezier(1, 0, 0, 1)"
                filter=".required"
                @start="drag=true"
                @end="dragEnd"
              >
                <div
                  v-for="(step, index) in wf.formatted_step"
                  :key="index"
                  class="timeline-item"
                >
                  <div
                    class="timeline-marker"
                    :class="[step.is_mandatory ? 'is-warning' : (step.show_details ? 'is-icon is-draggable is-info' : 'is-draggable')]"
                    style="font-family: monospace"
                  >
                    <i
                      v-if="!step.is_mandatory && step.show_details"
                      class="fas fa-arrows-alt"
                      aria-hidden="true"
                    />
                  </div>
                  <div class="timeline-content">
                    <step-new-edit
                      :step="step"
                      :index="index"
                      :tpl_list="tpl"
                      :workflow="wf"
                      @delete-step="deleteStep(index)"
                      @save-workflow="saveWorkflow()"
                      @computePeriods="step.current_period = $event; computePeriods()"
                      @validate-step="step = $event; validateStep(step)"
                      @update-step="(params) => updateStep(params, index)"
                      @toggle="step.show_details = !step.show_details"
                      @change="onChange($event, index)"
                    />
                  </div>
                </div>
              </draggable>
            </div>

            <div class="timeline-item timeline-item-end">
              <div class="timeline-marker" />
            </div>
          </div> -->
        </div>
        <div
          id="actionbar"
          class="actionbar-bottom bg-white dark:bg-muted-800 border-t border-muted-300 dark:border-muted-600"
        >
          <div class="container is-fullhd">
            <div class="columns py-4">
              <div class="flex justify-end w-full">
                <button
                  id="addNewStep"
                  class="button secondary is-outlined"
                  @click="addNewStep"
                >
                  <span class="icon"><i
                    class="fas fa-plus"
                    aria-hidden="true"
                  /></span>
                  <span>Add Step</span>
                </button>
                <button
                  id="saveWorkflow"
                  class="button primary"
                  @click="saveWorkflow"
                >
                  <span class="icon"><i
                    class="fas fa-save"
                    aria-hidden="true"
                  /></span>
                  <span>Save Workflow</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal if user leave without saving -->
        <div
          class="modal"
          :class="{'is-active' : show_modal_leaving}"
        >
          <div
            class="modal-background"
            @click="show_modal_leaving = false"
          />
          <div class="modal-content">
            <div class="box">
              <h6>Save template modification?</h6>
              <p>There are some unsaved changes. Would you like to save them before leaving the page?</p>
              <p
                class="control has-text-right"
                style="margin-top: 2rem"
              >
                <a
                  href="#"
                  class="button is-white"
                  @click="hideLeavingModal()"
                >Discard</a>
                <a
                  href="#"
                  class="button primary"
                  @click="saveAndRedirect"
                >Save</a>
              </p>
            </div>
          </div>
          <button
            class="modal-close is-large"
            aria-label="close"
            @click="show_modal_leaving = false"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import draggable from 'vuedraggable';
import StepNewEdit from './step/EditNew.vue';
import WorkflowService from '../../services/workflow.service';
import { makeUrlClickable } from '../../utils/validationUtils';

const workflowService = new WorkflowService();

export default {
  name: 'WorkflowDetails',
  components: {
    draggable,
    StepNewEdit
  },
  beforeRouteLeave(to, from, next) {
    if (this.track_formatted_step && this.hasUnsavedChange()) {
      this.show_modal_leaving = true;
      this.redirection_to = to;
      next(false);
    } else {
      this.checkForLogout();
      next();
    }
  },
  data() {
    return {
      wf: {
        default_possible_choices_list: {},
        default_possible_template_list: {},
        formatted_step: [],
        workflow: {}
      },
      tpl: {
        company: {},
        state: {}
      },
      track_formatted_step: [],
      show_modal_leaving: false,
      redirection_to: null,
      stateName: '',
      legalRules: '',
      errors: {
        workflowName: {
          visible: false,
          message: ''
        }
      },
      possibleStepErrors: {
        step: {
          visible: false,
          message: ''
        },
        notificationType: {
          visible: false,
          message: ''
        },
        contentSent: {
          visible: false,
          message: ''
        },
        period: {
          visible: false,
          message: ''
        }
      },
      stepPeriodFields: {
        1: 'lien_notice',
        2: 'lien_notice2',
        3: 'lien_sale',
        4: 'lien_sale2',
        5: 'newspaper1',
        6: 'newspaper2'
      },
      chosenState: this.$store.state.company.state
    };
  },
  mounted() {
    if (document.querySelector('#actionbar')) {
      document.querySelector('.padding-bottom-needed').style.paddingBottom = `${document.querySelector('#actionbar').offsetHeight * 2}px`;
    }
    const self = this;
    this.$root.pageTitle = 'Create a custom Workflow';
    let newWorkflow = true;
    // workflow/edit/:uuid -> so we're in edition mode for an EXISTING workflow
    if (this.$route.path.includes('workflow/edit')) {
      this.$root.pageTitle = 'Edit a custom workflow';
      newWorkflow = false;
    }
    this.$root.goBackLink = 'workflow-list';

    // is there an uuid in the link ? if so, we use this template
    let { uuid } = this.$route.params;

    if (!uuid) {
      // else we use the legal workflow from state
      uuid = this.$store.state.company.state.legal_workflow;
    }
    workflowService.editWorkflow(uuid)
      .then((response) => {
        const { status, result } = response.data;

        if (status === 'success') {
          const tmp = result;

          if (newWorkflow) {
            tmp.workflow.name = '';
            tmp.workflow.uuid = '';
          }
          tmp.formatted_step.forEach((step) => {
            // eslint-disable-next-line no-param-reassign
            step.current_period = step.period;
            // eslint-disable-next-line no-param-reassign
            step.show_details = false;
            // eslint-disable-next-line no-param-reassign
            step.errors = { ...self.possibleStepErrors };
          });

          self.track_formatted_step = JSON.parse(JSON.stringify(tmp.formatted_step));

          self.wf = tmp;
          self.$root.pageTitle = tmp.workflow.name;

          self.computePeriods();
        } else {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        }
      })
      .catch(() => {
        self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
      });

    const { state } = this.$store.state.company;
    this.stateName = state.name;
    this.legalRules = makeUrlClickable(state.legal_rules);
  },
  methods: {
    dragEnd() {
      this.computePeriods();
    },
    addNewStep(event) {
      event.preventDefault();
      this.wf.formatted_step.push({
        name: '',
        is_mandatory: 0,
        period: 0,
        current_period: 0,
        show_details: true,
        sum_days: this.wf.formatted_step[this.wf.formatted_step.length - 1].sum_days,
        possible_choices_list: null,
        possible_name_list: null,
        choice_name: '',
        is_alternate_required: true,
        errors: { ...this.possibleStepErrors }
      });
    },
    deleteStep(index) {
      this.wf.formatted_step.splice(index, 1);
      this.computePeriods();
    },
    computePeriods() {
      let sumDays = 0;
      this.wf.formatted_step.forEach((step) => {
        const currentPeriod = Math.max(0, Number(step.current_period));
        sumDays += currentPeriod;

        // eslint-disable-next-line no-param-reassign
        step.current_period = currentPeriod;
        // eslint-disable-next-line no-param-reassign
        step.sum_days = sumDays;
      });
    },
    validateWorkflow() {
      const workflowName = this.wf.workflow.name;
      const formattedStep = [...this.wf.formatted_step];

      if (!workflowName) {
        this.$root.$emit('showToast', { message: 'Workflow title is required', options: { cssClass: 'is-danger', duration: 10000 } });
        this.errors.workflowName = {
          visible: true,
          message: 'Workflow title is required'
        };
        this.$refs.title.focus();
        return false;
      } if (workflowName.length > 50) {
        this.$root.$emit('showToast', { message: 'Allowed character count is 50 for Workflow title', options: { cssClass: 'is-danger', duration: 10000 } });
        this.errors.workflowName = {
          visible: true,
          message: 'Allowed character count is 50'
        };
        return false;
      }
      this.errors.workflowName = {
        visible: false,
        message: ''
      };
      const invalidStepsIndex = this.getInvalidStepsIndex(formattedStep);

      if (invalidStepsIndex?.length) {
        this.$root.$emit('showToast', { message: 'Please make sure that all fields are filled in correctly', options: { cssClass: 'is-danger', duration: 10000 } });
        invalidStepsIndex.map((invalidStepIndex) => {
          formattedStep[invalidStepIndex] = {
            ...formattedStep[invalidStepIndex],
            show_details: true
          };
        });
        this.wf.formatted_step = [...formattedStep];
        return false;
      }
      return true;
    },
    getInvalidStepsIndex(steps) {
      const invalidStepsIndex = [];

      steps.map((step, index) => {
        const isValid = this.isStepValid(step);

        if (!isValid) {
          invalidStepsIndex.push(index);
        }
      });
      return invalidStepsIndex;
    },
    isStepValid(step, calledFromValidate) {
      let isValid = true;

      const { chosenState } = this;
      const currentPeriod = step.current_period;
      const choiceName = step.choice_name;
      const minPeriod = chosenState[this.stepPeriodFields[choiceName]];
      let periodErrorMessage = false;

      if (!currentPeriod && currentPeriod !== 0) {
        isValid = false;
        periodErrorMessage = 'Period is required';
        this.$root.$emit('showToast', { message: periodErrorMessage, options: { cssClass: 'is-success', duration: 5000 } });
      } else if (currentPeriod < minPeriod) {
        isValid = false;
        periodErrorMessage = `Minimum period for ${this.wf.default_possible_choices_name_list[choiceName].name} is ${minPeriod}`;
        this.$root.$emit('showToast', { message: periodErrorMessage, options: { cssClass: 'is-success', duration: 5000 } });
      }

      if (calledFromValidate && isValid) {
        this.$root.$emit('showToast', { message: 'Step is valid', options: { cssClass: 'is-success', duration: 5000 } });
      }
      return isValid;
    },
    validateStep(step) {
      this.isStepValid(step, true);
    },
    saveWorkflow(event, redirectionTo) {
      if (event) { event.preventDefault(); }
      const isValid = this.validateWorkflow();
      if (!isValid) {
        return;
      }
      this.computePeriods();
      const data = new FormData();
      const self = this;
      // eslint-disable-next-line
      data.append('formatted_steps', JSON.stringify(this.wf.formatted_step.map(({ show_details, errors, ...rest}) => (rest))));
      data.append('name', this.wf.workflow.name);
      data.append('uuid', this.wf.workflow.uuid);
      workflowService.saveWorkflow(this.$store.state.company.uuid, data)
        .then((response) => {
          const { status, message, result } = response.data;

          if (status === 'success') {
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-success', duration: 5000 } });
            self.wf.workflow.uuid = result.workflow_uuid;
            self.track_formatted_step = null;

            if (redirectionTo) {
              self.$router.push({ name: self.redirection_to.name });
              self.checkForLogout();
            } else {
              self.$router.push({ name: 'workflow-list' });
            }
          } else {
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    },
    saveAndRedirect() {
      this.saveWorkflow(null, true);
    },
    hideLeavingModal() {
      this.track_formatted_step = null;
      this.$router.push({ name: this.redirection_to.name });
      this.checkForLogout();
    },
    hasUnsavedChange() {
      if (this.track_formatted_step.length !== this.wf.formatted_step.length) return true;

      const dataToCheck = ['choice', 'name', 'template_name', 'current_period'];
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.wf.formatted_step.length; i++) {
        // eslint-disable-next-line no-plusplus
        for (let j = 0; j < dataToCheck.length; j++) {
          if (this.wf.formatted_step[i][dataToCheck[j]] !== this.track_formatted_step[i][dataToCheck[j]]) return true;
        }
      }

      return false;
    },
    onChange(step, index) {
      this.wf.formatted_step[index] = step;
    },
    checkForLogout() {
      if (this.$store.state.showLogout) {
        this.$store.commit('logout');
      }
    },
    updateStep(params, index) {
      const { key, value } = params;
      const formattedSteps = this.wf.formatted_step;
      const stepToUpdate = formattedSteps[index];

      if (stepToUpdate[key] !== value) {
        this.wf.formatted_step[index] = {
          ...this.wf.formatted_step[index],
          [key]: value
        };
        this.wf.formatted_step = [...this.wf.formatted_step];
      }
    }
  }
};
</script>
<style scoped src='../../../public/assets/css/bulma-extension/bulma-timeline.min.css'></style>
<style scoped src='../../../public/assets/css/bulma-extension/bulma-tooltip.min.css'></style>
<style scoped>
    .timeline-content {
        width: 100%;
    }

    .timeline .card {
        margin-bottom: .5em;
    }

    .columns {
        height: auto;
    }

    .is-draggable {
        cursor:grab;
    }

    /*.blurred {
        opacity: .7;
        filter: blur(2px);
    }*/

    .content h4 {
        margin-bottom: 0;
    }

    .timeline .timeline-item {
        padding: 1em 0;
    }

    .timeline .timeline-item .timeline-marker {
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .timeline .timeline-item.timeline-item-start,
    .timeline .timeline-item.timeline-item-end {
        padding-top: 0;
        padding-bottom: 0;
        margin-top: 0;
        margin-bottom: 0;
        font-size: .8em;
    }

    .timeline .timeline-item.timeline-item-start .timeline-content,
    .timeline .timeline-item.timeline-item-end .timeline-content {
        display: flex;
        justify-content: space-between;
        line-height: 1em;
    }

    .timeline .timeline-item.timeline-item-start:before,
    .timeline .timeline-item.timeline-item-end:before {
        display: none;
    }

    .timeline .timeline-item.timeline-item-start .timeline-marker {
        bottom: 0;
        top: auto;
        transform: translate(-50%, 0);
        width: 6px;
        height: 6px;
        left: 6px;
    }

    .timeline .timeline-item.timeline-item-end .timeline-marker {
        top: 0;
        bottom: auto;
        transform: translate(-50%, 0);
        width: 6px;
        height: 6px;
        left: 6px;
    }

    .timeline-marker.is-icon.is-draggable.is-info:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        animation: pulse 2s infinite;
    }

    @keyframes pulse {
        0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(var(--primary-blue), 0.7);
        }

        70% {
            transform: scale(1.2);
            box-shadow: 0 0 0 10px rgba(var(--primary-blue), 0);
        }

        100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(var(--primary-blue), 0);
        }
    }
</style>
